import { RedirectionTopBanner } from "~/features/regionSelection/components/RegionSelectionBanner";

export function createRegionSelectionBanner() {
  return <RedirectionTopBanner />;
}
